// import {parseStoreCompany} from "../Companies/helpers";
// import produce from "immer";
// import {
//   GET_CURRENT_REST_BPM,
//   INITIATE_INVOICE_EDIT,
//   REQUEST_AMOUNTS_CALCULATIONS,
//   REQUEST_COMPANY_INVOICES, REQUEST_COMPANY_TRANSPORT_LOCATIONS, REQUEST_EXACT_AUTH_LINK,
//   REQUEST_EXACT_AUTH_STATUS,
//   REQUEST_INVOICE,
//   REQUEST_INVOICE_FILTER,
//   REQUEST_INVOICE_STATUS_LIST,
//   REQUEST_INVOICES, REQUEST_VAT_CODES,
//   REQUEST_VEHICLE_INVOICES,
//   SET_EDIT_INVOICE_VALUE
// } from "../Invoices/constants";
// import {REQUEST_DATA_RESULT} from "../../containers/App/constants";
// import {REQUEST_COMPANY} from "../Companies/constants";
//
// const stringToDate = raw => (raw ? new Date(raw) : null);

import produce from 'immer';
import {
  REQUEST_PRODUCTS_BY_INVOICE,
  REQUEST_PRODUCT,
  REQUEST_PRODUCTS,
  REQUEST_PRODUCTS_FILTER,
  SET_NEW_PRODUCT_VALUE,
  REQUEST_GET_COUNTERS,
  REQUEST_PRODUCT_COMPANY_FIN_DATA,
  REQUEST_COMPANY_PRODUCTS_FILTER, REQUEST_COMPANY_PRODUCTS, REQUEST_COMPANY_PRODUCTS_IDS, REQUEST_COMPANY_PRODUCT,
  REQUEST_GET_ALL_PRODUCT_TASKS, REQUEST_GET_PRODUCT_TASKS,
} from './constants';
import { REQUEST_DATA_RESULT } from '../../containers/App/constants';
import { SET_NEW_VEHICLE_VALUE } from '../Vehicles/constants';
import { REQUEST_INVOICES } from '../Invoices/constants';
const mapProductListItem = raw => {
  if (!raw) return null;
  let relation = null;

  return {
    ...raw,
    relation,
  };
};

export const mapProduct = raw => ({
  ...raw,
  isOneTime: typeof raw.isOneTime === 'number' ? `${raw.isOneTime}` : raw.isOneTime,
  isCounter: typeof raw.isCounter === 'number' ? `${raw.isCounter}` : raw.isCounter,
  isTransport: typeof raw.isTransport === 'number' ? `${raw.isTransport}` : raw.isTransport,
  customFinData: (raw.customFinData ?? []).reduce((prev, curr) => {
    if (curr.taxRegion) prev[curr.taxRegion] = curr;
    return prev;
  }, {}),
});

export const initialState = {
  products: [],
  counters: [],
  filter: {
    searchString: null,
    offset: 0,
  },
  paginator: {},
  itemsCount: 0,
  newProduct: {},
};

export const productsReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case REQUEST_PRODUCTS_FILTER:
        if (action.name) {
          if (action.name === 'clear') {
            draft.filter = {
              searchString: null,
              offset: 0,
            };
          } else {
            if (action.value === null) {
              delete draft.filter[action.name];
            } else {
              draft.filter[action.name] = action.value;
            }
            //reset offset
            if (action.name !== 'offset') draft.filter.offset = 0;
          }
        }
        if (action.options && draft.filter) {
          draft.filter.options = action.options;
        }
        if (action.limit) {
          draft.filter.limit = action.limit;
        }
        break;
      case REQUEST_COMPANY_PRODUCTS_FILTER:
        if (action.name) {
          if (action.name === 'clear') {
            draft.companyFilter = {
              searchString: null,
              offset: 0,
            };
          } else {
            if (action.value === null) {
              delete draft.companyFilter[action.name];
            } else {
              if (!draft.companyFilter) {
                draft.companyFilter = { [action.name]: action.value };
              } else {
                draft.companyFilter[action.name] = action.value;
              }
            }
            //reset offset
            if (action.name !== 'offset') draft.companyFilter.offset = 0;
          }
        }
        if (action.options && draft.companyFilter) {
          draft.companyFilter.options = action.options;
        }
        break;
      case SET_NEW_PRODUCT_VALUE:
        if (action.initiate) {
          draft.newProduct[action.name] = draft.newProduct[action.name] || '';
        } else draft.newProduct[action.name] = action.value;
        return;
      // case INITIATE_INVOICE_EDIT:
      //   try {
      //     draft.newInvoice = {
      //       id: action.id,
      //     };
      //     let invoice = draft.invoicesById[action.id];
      //
      //     draft.newInvoice = { id: invoice?.id };
      //   } catch (e) {
      //     // eslint-disable-next-line no-debugger
      //     debugger;
      //   }
      //   break;
      // case SET_EDIT_INVOICE_VALUE:
      //   if (action.initiate) {
      //     draft.newInvoice[action.name] = draft.newInvoice[action.name] || '';
      //   } else draft.newInvoice[action.name] = action.value;
      //   return;
      case REQUEST_DATA_RESULT:
        switch (action.id) {
          case REQUEST_PRODUCTS:
            draft.products = [...action.result.items.map(i => mapProductListItem(i))];
            draft.paginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            break;
          case REQUEST_PRODUCT:
            draft.product = mapProduct(action.result);
            break;
          case REQUEST_PRODUCTS_BY_INVOICE:
            draft.products = [...action.result.items.map(i => mapProductListItem(i))];
            draft.paginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            break;
          case REQUEST_GET_COUNTERS:
            draft.counters = action.result;
            break;
          case REQUEST_PRODUCT_COMPANY_FIN_DATA:
            draft.productCompanyFinData = action.result;
            break;
          case REQUEST_COMPANY_PRODUCTS:
            draft.companyProducts = [...action.result.items.map(i => mapProductListItem(i))];
            draft.companyPaginator = action.result.paginator;
            draft.itemsCount = action.result.paginator.itemsCount;
            break;
          case REQUEST_COMPANY_PRODUCTS_IDS:
            draft.companyProductsIds = action.result;
            break;
          case REQUEST_COMPANY_PRODUCT:
            draft.companyProduct = action.result;
            break;
          case REQUEST_GET_ALL_PRODUCT_TASKS:
            draft.allProductTasks = action.result;
            break;
          case REQUEST_GET_PRODUCT_TASKS:
            draft.productTasks = action.result;
            break;
        }
    }
  });
